module.exports = __webpack_public_path__ + "media/india-sound.ba65c26f.mp3";